import {useSyncExternalStore} from 'react';
import {subscribe, getSnapshot} from '@hooks/dockStore';

// Thin subscriber over the shared dock controller (see dockStore.js).
// `offsetTop` mirrors the visible header height and is also exposed as the CSS
// variable --sh-header-offset, which drives the tabs `top` in the stylesheet so
// the docking animation stays synchronized with the header.
const useDockedTabs = () => {
	const snapshot = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

	return {
		isFixed: snapshot.isTabsFixed,
		offsetTop: snapshot.headerOffset,
	};
};

export default useDockedTabs;